import React, {useEffect, useRef, useState} from "react";
import {IconButton, Tooltip} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {CheckIcon, Copy01Icon} from "@hugeicons/core-free-icons";
import {toast} from "react-toastify";

// Icon button that copies `text` to the clipboard and shows a check for a moment
export const CopyCodeButton = ({text, size = 15, ...rest}) => {
    const [copied, setCopied] = useState(false);
    const timer = useRef(null);

    useEffect(() => () => clearTimeout(timer.current), []);

    const copy = async (event) => {
        event.stopPropagation();
        try {
            await navigator.clipboard.writeText(text || "");
            setCopied(true);
            clearTimeout(timer.current);
            timer.current = setTimeout(() => setCopied(false), 1500);
        } catch (error) {
            toast.error("Could not copy to the clipboard");
        }
    };

    return (
        <Tooltip title={copied ? "Copied" : "Copy"}>
            <span>
                <IconButton size="small" disabled={!text} onClick={copy} {...rest}>
                    <HugeiconsIcon icon={copied ? CheckIcon : Copy01Icon} size={size}/>
                </IconButton>
            </span>
        </Tooltip>
    );
};
